module.exports = __webpack_public_path__ + "static/img/event21.8a3f466.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event21.png
// module id = QOem
// module chunks = 1